<template>
 <div class="fc-page mg-page rp-page rp-recharge_dashboard">
  <nav aria-label="面包屑"><v-breadcrumbs :items="breadcrumbs" divider="/" class="mg-breadcrumb" /></nav>
  <header class="fc-heading"><div><h1>缴费与消课收入报表</h1><p>对比月度缴费与消课收入，查看课程和班级收入分布</p></div><span class="rp-heading-symbol" aria-hidden="true"><v-icon size="25" color="#d9363e">mdi-chart-box-outline</v-icon></span></header>
  <section class="fc-filters rp-year-filters" aria-label="统计年份筛选"><div class="fc-filter-heading"><h3>统计范围</h3><span>选择年份后查询</span></div><form class="rp-year-form" @submit.prevent="refresh"><div class="fc-filter-cell"><v-select :items="yearItems" v-model="query.year" item-text="name" item-value="value" label="年份" dense outlined hide-details color="#d9363e" /></div><v-btn type="submit" depressed color="#d9363e" dark><v-icon left size="17">mdi-magnify</v-icon>查询</v-btn></form></section>
  <div class="rp-chart-grid">
   <article class="rp-chart"><div class="rp-chart-heading"><div><h3>月度缴费金额</h3><p>按月查看学员缴费情况</p></div></div><div class="rp-chart-body"><ve-histogram v-if="monthRechargeData.rows.length" :data="monthRechargeData" :colors="['#d9363e','#6087b1','#6ca68e','#d6ab68','#9b87af']" :judge-width="true" height="360px" :extend="Object.assign({}, chartExtend, {title:{show:false},textStyle:{fontFamily:'Microsoft YaHei',color:'#718096'},'legend.textStyle':{color:'#718096'}})" /><div v-else class="rp-chart-empty" role="status"><v-icon size="32">mdi-chart-box-outline</v-icon><h4>暂无统计数据</h4><p>当前查询范围内暂无可展示的记录</p></div></div><div v-if="summaryText" class="rp-chart-summary">{{summaryText}}</div></article>
   <article class="rp-chart"><div class="rp-chart-heading"><div><h3>月度消课收入</h3><p>按月查看课程核销收入</p></div></div><div class="rp-chart-body"><ve-histogram v-if="monthRevenueData.rows.length" :data="monthRevenueData" :colors="['#d9363e','#6087b1','#6ca68e','#d6ab68','#9b87af']" :judge-width="true" height="360px" :extend="Object.assign({}, chartExtend, {title:{show:false},textStyle:{fontFamily:'Microsoft YaHei',color:'#718096'},'legend.textStyle':{color:'#718096'}})" /><div v-else class="rp-chart-empty" role="status"><v-icon size="32">mdi-chart-box-outline</v-icon><h4>暂无统计数据</h4><p>当前查询范围内暂无可展示的记录</p></div></div></article>
   <article class="rp-chart"><div class="rp-chart-heading"><div><h3>课程消课收入 TOP5</h3><p>按课程查看消课收入构成</p></div></div><div class="rp-chart-body"><ve-pie v-if="courseRevenueData.rows.length" :data="courseRevenueData" :colors="['#d9363e','#6087b1','#6ca68e','#d6ab68','#9b87af']" :judge-width="true" height="360px" :extend="Object.assign({}, {}, {title:{show:false},textStyle:{fontFamily:'Microsoft YaHei',color:'#718096'},'legend.textStyle':{color:'#718096'}})" /><div v-else class="rp-chart-empty" role="status"><v-icon size="32">mdi-chart-box-outline</v-icon><h4>暂无统计数据</h4><p>当前查询范围内暂无可展示的记录</p></div></div></article>
   <article class="rp-chart"><div class="rp-chart-heading"><div><h3>班级消课收入 TOP5</h3><p>按班级查看消课收入构成</p></div></div><div class="rp-chart-body"><ve-pie v-if="classRevenueData.rows.length" :data="classRevenueData" :colors="['#d9363e','#6087b1','#6ca68e','#d6ab68','#9b87af']" :judge-width="true" height="360px" :extend="Object.assign({}, {}, {title:{show:false},textStyle:{fontFamily:'Microsoft YaHei',color:'#718096'},'legend.textStyle':{color:'#718096'}})" /><div v-else class="rp-chart-empty" role="status"><v-icon size="32">mdi-chart-box-outline</v-icon><h4>暂无统计数据</h4><p>当前查询范围内暂无可展示的记录</p></div></div></article>
  </div>
 </div>
</template>

<script>
	import utils from "../../../config/utils"
	export default {
		name: "recharge-dashboard",
		data() {
			this.chartExtend = {
			 //  title: {
				// text: '缴费&消课收入报表'
			 //  },
			  series: {
				barWidth: 40,
				label:{show:true,position:'top'}
			  }
			},
			this.rechargeExtend={
				series: {
					barWidth: 40,
					label:{show:true,position:'right'}
				}
			}
			return {
				breadcrumbs: [{
						text: '首页',
						disabled: false,
						href: "/"
					},
					{
						text: '数据报表',
						disabled: true
					},
					{
						text: '缴费&消课收入报表',
						disabled: true
					},
				],
				shopId:"",
				yearItems:[],
				chartData: {
					columns: ['月份', '缴费金额',"消课收入"],
					rows: [], 
				},
				summaryText:"",
				query: {
					year:""+new Date().getFullYear()
				},
				chartData: {
					columns: ['月份', '缴费金额',"消课收入"],
					rows: [], 
				},
				monthRechargeData: {
					columns: ['月份', '缴费金额'],
					rows: [], 
				},
				monthRevenueData: {
					columns: ['月份', "消课收入"],
					rows: [], 
				},
				courseRevenueData: {
					columns: ['课程名称', '消课收入'],
					rows: [], 
				},
				classRevenueData:{
					columns: ['班级名称', '消课收入'],
					rows: [], 
					
				}
			}
		},
		mounted() {

		},
		created() {
			this.generateYearItems();
			this.shopId = utils.getCurrentShopId();
			this.getChartData();
			this.getCourseRevenueTopList();
			this.getClassRevenueTopList();
		},
		methods: {
			generateYearItems(){
				let fromYear = 2018;
				const now = new Date();
				const nowYear = now.getFullYear();
				
				for (let i = fromYear; i <= nowYear; i++) {
					this.yearItems.push({value:i.toString(),name:i.toString()+"年"})
				}
			},
			refresh(){
				this.getChartData();
				this.getCourseRevenueTopList();
				this.getClassRevenueTopList();
			},
			getChartData() {
				const that = this;

				let url = `/report/recharge/dashboard/${this.query.year}?v=1`;
				if (this.shopId) {
					url += "&shopId=" + this.shopId;
				}
				
				this.axios.get(url).catch(()=>{
					return;
				}).then(response => {
					
					if (response.data["code"] === 200) {
						
						console.log(response.data["data"]["dataList"]);
						
						const dataList = response.data["data"]["dataList"] || [];
						
						let rechargeList = [];
						let revenueList = [];
						if (dataList.length > 0){
							dataList.forEach((item,index)=>{
								let recharge = {"月份":item.month,"缴费金额":item.rechargeAmount}
								let revenue = {"月份":item.month,"消课收入":item.revenueAmount}
								rechargeList.push(recharge);
								revenueList.push(revenue);
								
							})
						}
						
						// 按月充值金额
						that.monthRechargeData.rows = rechargeList;
						// 按月消课收入
						that.monthRevenueData.rows = revenueList;
						
						
						that.summaryText  =  response.data["data"]["summaryText"];
						return
					}else{
						that.$noty.error("获取失败：" + response.data["message"]);
					}
				
					
				})
			},
			getCourseRevenueTopList(){
				// 获取课程消课排行
				const that = this;
				let url = `/report/course/revenue/amount/top/5?v=1`;
				if (this.shopId) {
					url += "&shopId=" + this.shopId;
				}
				if(this.query.year){
					url += "&year=" + this.query.year;
				}
				
				this.axios.get(url).then(response => {
					
					if (response.data["code"] === 200) {
						const dataList = response.data["data"]["dataList"] || [];
						console.log("course top 5",dataList);
						
						that.courseRevenueData.rows = dataList;
						
						return
					}
				})
			},
			getClassRevenueTopList(){
				// 获取班级消课排行
				const that = this;
				let url = `/report/class/revenue/amount/top/5?v=1`;
				if (this.shopId) {
					url += "&shopId=" + this.shopId;
				}
				if(this.query.year){
					url += "&year=" + this.query.year;
				}
				
				this.axios.get(url).then(response => {
					
					if (response.data["code"] === 200) {
						const dataList = response.data["data"]["dataList"] || [];
						console.log("class top 5",dataList);
						
						that.classRevenueData.rows = dataList;
						
						return
					}
				})
			}
		}
	}
</script>

<style lang="scss" scoped>
@import "../../../assets/styles/reports-management.scss";
</style>
